"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";
import "react-table/react-table.css";

import Section from "../../component/Template/Section";
import EnrichedVideoTable from "../../component/EnrichedVideo/Widget/EnrichedVideoTable";

import {filterContextToRequestParams, onFilterContextDidUpdate} from "../../context/FilterContext/Util";

import {apiPath} from "../../const";
import {getRequest} from "../../service/api/request";

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;


class EnrichedVideosInCatalogue extends Component {

    static defaultProps = {
        defaultPageSize: 20,
        defaultSorted: [{id: "lastModifiedDate", desc: true}],
        defaultSortDesc: true,
    };

    static propTypes = {
        defaultPageSize: PropTypes.number,
        defaultSorted: PropTypes.array,
        defaultSortDesc: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        let filtered = [{ id: 'search', value: '' }];
        let filterContext = filterContextToRequestParams(props.filterContext);
        Object.keys(filterContext).forEach(filterContextKey => {
            if (!(filterContext[filterContextKey] instanceof Function))
                filtered.push({id: filterContextKey, value:filterContext[filterContextKey]});
        });

        this.state = {
            data: [],
            search: '',
            filtered: filtered,
            pages: null,
            loading: true,
            filterContext: props.filterContext,
        };

        this.onFetchData = this.onFetchData.bind(this);
        this.onChangeSearch = this.onChangeSearch.bind(this);
    }

    componentWillMount() {
        this.searchTimeoutHandle = 0;
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {
        onFilterContextDidUpdate(prevProps.filterContext,
            this.props.filterContext,
            () => this.triggerSearch());
    }

    onFetchData(state, instance) {
        this.setState({ loading: true });

        const enrichedVideosApiPath = apiPath + "/enrichedVideos/search/searchCatalogue";

        let params = {};
        params.size = state.pageSize;
        params.page = state.page;
        params.sort = state.sorted.map(sort => sort.id + "," + (sort.desc ? "desc" : "asc"));
        state.filtered.forEach((filter) => {
            params[filter.id] = filter.value;
        });

        getRequest(
            enrichedVideosApiPath,
            params
        ).then(response => {
            const res = {
                data: response.entity._embedded.enrichedVideos,
                pages: response.entity.page.totalPages,
            };
            this.setState({
                data: res.data,
                pages: res.pages,
                loading: false,
            });
        });
    }

    onChangeSearch(e) {
        const self = this;

        if (self.searchTimeoutHandle) {
            clearTimeout(self.searchTimeoutHandle);
        }

        const { value } = e.target;
        const search = value;
        this.setState({ search });

        self.searchTimeoutHandle = setTimeout(() => self.triggerSearch(), WAIT_INTERVAL)
    }

    onKeyDownSearch(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerSearch();
        }
    }

    triggerSearch() {
        const {search} = this.state;
        let filterContext = filterContextToRequestParams(this.props.filterContext);

        let filtered = [];

        if (search) filtered.push({ id: 'search', value: search });

        Object.keys(filterContext).forEach(filterContextKey => {
            if (!(filterContext[filterContextKey] instanceof Function))
                filtered.push({id: filterContextKey, value:filterContext[filterContextKey]});
        });

        this.setState({ filtered });
    }

    render() {
        const { data, search, filtered, pages, loading } = this.state;
        const { defaultPageSize, defaultSorted, defaultSortDesc } = this.props;

        return (
            <div>
                <Section className="content-header">
                    <h1>Scheduled Enriched Videos <small>Available in Catalogue</small></h1>
                </Section>
                <Section className="content">
                    <div className="form-group">
                        <input id="search" type="text" className="form-control" placeholder="Search..."
                               value={search} onChange={this.onChangeSearch} onKeyDown={this.onKeyDownSearch} />
                    </div>
                    <EnrichedVideoTable
                        manual={true} // Forces table not to paginate or sort automatically, so we can handle it server-side
                        loading={loading} // Display the loading overlay when we need it
                        data={data}
                        filtered={filtered}
                        pages={pages} // Display the total number of pages
                        defaultPageSize={defaultPageSize}
                        defaultSorted={defaultSorted}
                        defaultSortDesc={defaultSortDesc}
                        onFetchData={this.onFetchData} />
                    />
                </Section>
            </div>
        );
    }
}

export default EnrichedVideosInCatalogue;
